<template>
  <div>
    <div style="text-align: right; margin-bottom: 10px;vertical-align:middle">
      <!-- <el-button type="text" size="mini" icon="el-icon-download" style="width:21px;fontSize:20px;margin-right:20px;padding:0;vertical-align:middle;"></el-button> -->
      <downLoad style="display:inline-block" :message="this.fileMessage" :chartsName="fileName" :dateTime="fileDateTime"></downLoad>
      <el-select
        style="margin-right: 20px"
        size="mini"
        v-model="timeFilterType"
        @change="timerFilterTypeSelectChange"
      >
        <el-option
          v-for="item in timerFilterTypeOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-date-picker
        size="mini"
        v-model="timer"
        type="datetimerange"
        align="right"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :default-time="['00:00:00', '23:59:59']"
        @change="mothRangeChange"
      >
      </el-date-picker>
    </div>

    <div
      v-loading="loading"
      :id="id"
      :class="className"
      :style="{ height: height, width: width }"
    ></div>
    <div>总销售金额:¥ {{ saleAllPrice }}</div>
  </div>
</template>

<script>
import { timeOffset } from '@/utils/zoneTime.js'
import * as echarts from 'echarts'
import resize from './mixins/resize'
import { getReportUserSale, getTimeFilterOptions } from '@/api/outStorage.js'
import downLoad from '@/components/Charts/downLoad.vue'
export default {
  mixins: [resize],
  components: {
    'downLoad': downLoad
  },
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    id: {
      type: String,
      default: 'chart',
    },
    height: {
      type: String,
      default: '200px',
    },
    width: {
      type: String,
      default: '200px',
    },
  },
  created() {},
  async mounted() {
    var now = new Date() //当前日期
    var nowMonth = now.getMonth() //当前月
    var nowYear = now.getFullYear() //当前年
    //本月的开始时间
    var timeStar = new Date(nowYear, nowMonth, 1)
    //本月的结束时间
    var timeEnd = new Date(nowYear, nowMonth + 1, 0, 23, 59, 59)

    this.timer = [timeStar, timeEnd]
    let { data } = await getTimeFilterOptions()

    this.timeFilterType = data[0].value
    this.timerFilterTypeOptions = data
    this.getReport()
  },
  data() {
    return {
      loading: false,
      chart: null,
      data: null,
      timer: '',
      timeFilterType: null,
      timerFilterTypeOptions: [],
      fileMessage: [],   //传递给子组件的数据
      fileName: '',   //传递给子组件的文件名
      fileDateTime : null   //传递给子组件的文件名的时间段
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      if (this.chart) {
        this.chart.dispose()
        this.chart = null
      }

      this.chart = echarts.init(document.getElementById(this.id))

      let option = {
        title: {
          text: '用户消费占比饼状图',
          subtext: '',
          left: 'center',
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : ¥ {c} ({d}%)',
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: 10,
          top: 20,
          bottom: 20,
        },
        series: [
          {
            name: '用户消费金额',
            type: 'pie',
            radius: '50%',
            data: this.data ?? [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      }
      this.fileName = option.title.text;
      option && this.chart.setOption(option)
    },
    timerFilterTypeSelectChange(val) {
      this.timeFilterType = val
      this.getReport()
    },
    async getReport() {
      this.loading = true
      let timerFilter = {}

      if (this.timer) {
        timerFilter = {
          startTime: timeOffset(this.timer[0]),
          endTime: timeOffset(this.timer[1]),
        }
      }

      if (this.timeFilterType) {
        timerFilter.timeFilterType = this.timeFilterType
      }

      console.log(this.timer)
      console.log(timerFilter)
      this.fileDateTime = timerFilter;
      let { data } = await getReportUserSale(timerFilter)

      this.data = data
      this.fileMessage = data;
      this.initChart()
      this.loading = false
    },
    mothRangeChange(timer) {
      this.getReport()
    },
  },
  computed: {
    saleAllPrice() {
      let sumPrice = 0
      if (!this.data) {
        return sumPrice
      }

      this.data.forEach((item) => {
        sumPrice += item.value
      })

      return sumPrice.toFixed(2)
    },
  },
}
</script>

<style lang="scss" scoped></style>
